import React from 'react'
import {Field, reduxForm} from 'redux-form'
import Captcha from '../../Captcha'

const validate = values => {
  const requiredMsg = "Este campo é obrigatório";
  const errors = {};

  if (!values.email) {
    errors.email = requiredMsg
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
    errors.email = 'Endereço de e-mail inválido'
  }

  if (!values.tipo) {
    errors.tipo = requiredMsg
  } else if (values.tipo !== 'AUDITOR' && values.tipo !== 'OPERADOR') {
    errors.tipo = "Tipo de conta, inválido"
  }

  if (!values.captcharesponse) {
    errors.captcharesponse = "Por favor, confirme o Captcha"
  }

  return errors
};

const renderField = ({
                       input,
                       label,
                       type,
                       meta: {touched, error, warning}
                     }) => (
  <div className='form-group'>
    <label className='mt-3' htmlFor={input.name}>{label}</label>
    <input {...input} id={input.name} placeholder={label} type={type}
           className={`form-control ${touched && ((error && 'is-invalid'))}`}
    />

    {touched && ((error && <span className='text-danger'>{error}</span>) || (warning &&
      <span className='text-warning'>{warning}</span>))}
  </div>
);

const renderChkBoxField = ({
                             input,
                             label,
                             text,
                             type,
                             meta: {touched, error}
                           }) => (
  <div className='form-group'>
    <label className='mt-3'>{label}
      <input {...input} id={input.name} type={type} className={`${touched && ((error && 'is-invalid'))}`} />
      {` ${text}`}
    </label>

    {touched && (error && <span className='text-danger'>{error}</span>)}
  </div>
);

// const renderSelectField = ({
//                              input,
//                              label,
//                              meta: {touched, error, warning},
//                              children,
//                              ...custom
//                            }) => (
//   <div className='form-group'>
//     <label className='mt-3' htmlFor={input.name}>{label}</label>
//     <select {...input} id={input.name} placeholder={label}
//             className={`form-control ${touched && ((error && 'is-invalid'))}`} children={children} {...custom} />
//
//     {touched && ((error && <span className='text-danger'>{error}</span>) || (warning &&
//       <span className='text-warning'>{warning}</span>))}
//   </div>
// );


const FormIntegrar = props => {
  const {handleSubmit, submitting} = props;
  return (
    <form onSubmit={handleSubmit}>

      <h2>Cadastro de Estabelecimento</h2>


      <div className="row">
        <div className="col">

          <Field name="email" type="text" component={renderField} label="E-mail"/>

        </div>
      </div>

      {/*<div className="row">*/}
        {/*<div className="col">*/}

          {/*<Field name="tipo" component={renderSelectField} label="Tipo de conta">*/}
            {/*<option value="">Selecione</option>*/}
            {/*<option value="AUDITOR">Auditor</option>*/}
            {/*<option value="OPERADOR">Operador</option>*/}
          {/*</Field>*/}

        {/*</div>*/}
      {/*</div>*/}

      <div className="row">
        <div className="col">

          <Field
            name='receberComunicados'
            type='checkbox'
            text='Concordo em receber as comunicações institucionais do MeiaEntrada, ciente de que meus dados não serão compartilhados.'
            component={renderChkBoxField}
          />
        </div>
      </div>

      <div className="row">
        <div className="col text-center">
          <Field name='captcharesponse' component={Captcha}/>
        </div>
      </div>

      <div className="text-center">
        <button type="submit" disabled={submitting} className='btn btn-success'>
          Cadastrar
        </button>
      </div>

    </form>
  )
};

export default reduxForm({
  form: 'formIntegrar', // a unique identifier for this form
  validate, // <--- validation function given to redux-form
  initialValues: {receberComunicados: true}
})(FormIntegrar)



// WEBPACK FOOTER //
// ./src/components/views/Validador/FormIntegrar.js